import React, { useEffect, useState } from "react"
import { useLang } from "~/hooks/useLang";
import { getOutServiceReason } from "./Services";
import type { OutOfServiceResponse } from "./types";
import { Autocomplete, FormControl, TextField } from "@mui/material";

interface FilterAutocompleteMotiveOutOfServiceProps {
  readonly motiveOutOfServiceId: number | null;
  readonly onMotiveOutOfServiceIdChange: (value: number | null) => void;
  readonly label: string;
  readonly disabled?: boolean;
}

export default function FilterAutocompleteMotiveOutOfService({ motiveOutOfServiceId, label, disabled, onMotiveOutOfServiceIdChange }: FilterAutocompleteMotiveOutOfServiceProps) {
  const { translate } = useLang()
  const [options, setOptions] = useState<readonly OutOfServiceResponse[]>([])
  const [value, setValue] = useState<OutOfServiceResponse | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getOutServiceReason().then((motives) => {
      setOptions(motives)
      setValue(null)
    })
    .finally(() => {
      setLoading(false)
    })
  }, [])

  useEffect(() => {
    if (!motiveOutOfServiceId) {
      setValue(null)
    } else {
      setValue(options.find(item => item.id == motiveOutOfServiceId) ?? null)
    }
  }, [motiveOutOfServiceId, options])

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        id="filter-devices"
        options={options}
        disabled={disabled}
        value={value}
        noOptionsText={translate('No options')}
        clearText={translate('Clear')}
        size="small"
        loading={loading}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name ?? ''}
        onChange={(_, motive) => {
          setValue(motive)
          onMotiveOutOfServiceIdChange(motive?.id ?? null)
        }}
        renderInput={(params) => (
          <TextField {...params} label={translate(label ? label : 'Motive')} />
        )}
      />
    </FormControl>
  )
}